import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";

import CreaFecha from "../Modals/crear/CreaFechaSolicitud";
import { obtenerFechaVisitaSolicitudes } from "../../Services/Rest";
import Cookies from "universal-cookie";

function InfoFechas(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerFechaVisitaSolicitudesPorSolicitudId?SolicitudId=" +
        props.idSolicitud,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <Fragment>
      <div className="text-center">
        <div class="container-fluid">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">
                Fechas Propuestas
              </h6>
            </div>
            <div class="card-body">
              {cookies.get("tipo_Usuario") == 2 ? (
                <CreaFecha idSolicitud={props.idSolicitud} />
              ) : (
                <h1></h1>
              )}
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Fecha</th>
                      <th>Comentarios</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.fecha}</td>
                          <td>{item.comentarios}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoFechas;
